import React from "react";
import {
    Grid,
    Typography,
} from "@material-ui/core";
import styled from "styled-components";

const MainContainer = styled(Grid)`
  height: 100%;
`;

const Logo = styled.img`
  height: 100px;
  width: 100px;
  margin-bottom: 35px;
`;

const Text = styled(Typography)`
  text-transform: uppercase;
  font-weight: 600;
`;

const PlaceHolderView = (props:any) => {
    const {text, icon} = props;
    return (
       <MainContainer
           container
           direction={'column'}
           justify={'center'}
           alignItems={'center'}
       >
               <Grid item>
                   <Logo src={icon} />
               </Grid>
               <Grid item>
                   <Text>
                       {text}
                   </Text>
               </Grid>
       </MainContainer>
    );
};

export default PlaceHolderView;